import { API_URL } from '../../shared/actions'
import { customReducer } from './customReducer'

export const companyReducer = (state, action) => {
  const {
    COMPANY: { GET_ALL_COMPANIES, ADD_COMPANY, EDIT_COMPANY, DELETE_MANY_COMPANY },
  } = API_URL
  return customReducer(state, action, 'companies', [GET_ALL_COMPANIES, ADD_COMPANY, EDIT_COMPANY, DELETE_MANY_COMPANY])
}

export const superAdminReducer = (state, action) => {
  const {
    SUPERADMIN: { GET_ALL_SUPERADMINS, ADD_SUPERADMIN, EDIT_SUPERADMIN, DELETE_MANY_SUPERADMIN },
  } = API_URL
  return customReducer(state, action, 'superAdmins', [GET_ALL_SUPERADMINS, ADD_SUPERADMIN, EDIT_SUPERADMIN, DELETE_MANY_SUPERADMIN])
}

export const subscriptionReducer = (state, action) => {
  const {
    SUBSCRIPTIONS: { GET_ALL_SUBSCRIPTIONS, ADD_SUBSCRIPTION, EDIT_SUBSCRIPTION, DELETE_SUBSCRIPTION, GET_SUBSCRIPTION },
  } = API_URL
                                        // (state, action, key = [], cases = [])
  return customReducer(state, action, 'subscriptions', [GET_ALL_SUBSCRIPTIONS, ADD_SUBSCRIPTION, EDIT_SUBSCRIPTION, DELETE_SUBSCRIPTION, GET_SUBSCRIPTION])
}

// export const permissionReducer = (state, action) => {
//   const {
//     SUBSCRIPTIONS: { ACTIVE_SUBSCRIPTIONS },
//   } = API_URL
//                                         // (state, action, key = [], cases = [])
//   return customReducer(state, action, 'permissions', [ACTIVE_SUBSCRIPTIONS])
// }
